import { ReactComponent as SoundOnIcon } from "components/icons/soundOnIcon.svg";
import { ReactComponent as SoundOffIcon } from "components/icons/soundOffIcon.svg";

export const SoundButton = (props: {
  enabled: boolean;
  onClick: () => void;
}): JSX.Element => {
  return (
    <div className="sound" onClick={props.onClick}>
      {props.enabled ? (
        <SoundOnIcon />
      ) : (
        <SoundOffIcon />
      )}

      <div className="label">{props.enabled ? "On" : "Off"}</div>
    </div>
  );
};
